/**
 * FitVids custom selector constants.
 *
 * These selectors are used to identify video iframes from providers that aren't
 * natively supported by fitVids (which handles YouTube, Vimeo, and Kickstarter by default).
 *
 * Legacy providers are kept for backward compatibility with existing content.
 * Modern providers are added to support current video platforms.
 *
 * @since ??
 */

/**
 * Custom selector string for fitVids to handle additional video providers.
 *
 * This selector targets iframes from video providers that need custom handling.
 * FitVids natively supports:
 * - YouTube (youtube.com, youtube-nocookie.com)
 * - Vimeo (player.vimeo.com)
 * - Kickstarter (kickstarter.com with video.html).
 *
 * @since ??
 */
export const FITVIDS_CUSTOM_SELECTOR =
  // Legacy providers (kept for backward compatibility).
  "iframe[src^='http://www.hulu.com'], " +
  "iframe[src^='https://www.hulu.com'], " +
  "iframe[src^='http://www.dailymotion.com'], " +
  "iframe[src^='https://www.dailymotion.com'], " +
  "iframe[src^='http://www.funnyordie.com'], " +
  "iframe[src^='https://www.funnyordie.com'], " +
  "iframe[src^='https://embed-ssl.ted.com'], " +
  "iframe[src^='http://embed.revision3.com'], " +
  "iframe[src^='https://embed.revision3.com'], " +
  "iframe[src^='https://flickr.com'], " +
  "iframe[src^='http://blip.tv'], " +
  "iframe[src^='https://blip.tv'], " +
  "iframe[src^='http://www.collegehumor.com'], " +
  "iframe[src^='https://www.collegehumor.com'], " +
  // Modern providers.
  "iframe[src^='https://www.tiktok.com'], " +
  "iframe[src^='https://www.instagram.com'], " +
  "iframe[src^='https://www.facebook.com'], " +
  "iframe[src^='https://www.twitch.tv'], " +
  "iframe[src^='https://fast.wistia.net'], " +
  "iframe[src^='https://wistia.com'], " +
  "iframe[src^='https://www.loom.com'], " +
  "iframe[src^='https://play.vidyard.com'], " +
  "iframe[src^='https://players.brightcove.net'], " +
  "iframe[src^='https://content.jwplatform.com'], " +
  "iframe[src^='https://cdn.jwplayer.com']";
